export default "/favicon.svg"